import React, {FunctionComponent, useContext} from "react";
import {ExtraRegistrationFields} from "/src/domain/shared/Page";
import { ChallengeRegistrationContext, ChallengeRegistrationContextProps } from "/src/contexts/ChallengeRegistrationContext";
import {FormControl, FormHelperText, TextField} from "@mui/material";
import {DistanceSelect} from "/src/ui/challengesRegistration/registrationForm/DistanceSelect";
import {GenderSelect} from "/src/ui/challengesRegistration/registrationForm/GenderSelect";
import {GazpromUnitSelect} from "/src/ui/challengesRegistration/registrationForm/GazpromUnitSelect";
import {NostraPrediction} from "/src/ui/challengesRegistration/prediction/NostraPrediction";
import {RegionSelect} from "/src/ui/challengesRegistration/registrationForm/RegionSelect";
import {ChallengeLocationSelect} from "/src/ui/challengesRegistration/registrationForm/ChallengeLocationSelect";
import {TeamRegistrationView} from "/src/ui/challengesRegistration/teamRegistration/TeamRegistration";
import {RegistrationFormProps} from "/src/ui/challengesRegistration/registrationForm/RegistrationFormProps";
import {AdditionalProfileDataFields} from "/src/ui/challengesRegistration/registrationForm/AdditionalProfileDataFields";
import {makeStyles} from "@mui/styles";
import {theme} from "/src/assets/theme";
import {useTranslation} from "react-i18next";

export const RegistrationFormContent: FunctionComponent<RegistrationFormProps> = ({
                                                                                      currentUser,
                                                                                      extraFields,
                                                                                      challengeData, 
                                                                                  }) => {
    const classes = useStyles();
    const {t} = useTranslation();
    const { email, setEmail, additionalProfileData, setAdditionalProfileData } = useContext(ChallengeRegistrationContext) as ChallengeRegistrationContextProps;

    if (currentUser.challengeRegistration.isRegistered) {
        return (<ChallengeLocationSelect locations={challengeData.locations}
                                         locationDescription={challengeData.locationDescription}/>);
    } else {
        return (
            <>
                <FormControl className={classes.textFieldContainer}>
                    <TextField
                        className={classes.textField}
                        name="email"
                        required
                        type={"email"}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        label={"E-mail"}
                    />
                    <FormHelperText>{t('emailPlaceholder')}</FormHelperText>
                </FormControl>
                <AdditionalProfileDataFields
                    userData={{
                        firstName: currentUser.firstName || '',
                        lastName: currentUser.lastName || '',
                        birthDate: currentUser.birthDate || ''
                    }}
                    profileData={additionalProfileData}
                    setProfileData={setAdditionalProfileData}
                    currentDateMsk={challengeData.currentDateMsk}
                />
                {extraFields && extraFields?.indexOf(ExtraRegistrationFields.DISTANCE) >= 0 &&
                    <DistanceSelect distances={challengeData.distances || []}/>}
                {extraFields && extraFields?.indexOf(ExtraRegistrationFields.FIO) >= 0 &&
                    <FormControl className={classes.textFieldContainer}>
                        <TextField
                            className={classes.textField}
                            name="fio"
                            required
                            label={t('fioLabel')}
                        />
                    </FormControl>}
                {extraFields && extraFields?.indexOf(ExtraRegistrationFields.GENDER) >= 0 && <GenderSelect/>}
                {extraFields && extraFields?.indexOf(ExtraRegistrationFields.AGE) >= 0 &&
                    <FormControl className={classes.textFieldContainer}>
                        <TextField
                            className={classes.textField}
                            name="age"
                            required
                            label={t('ageLabel')}
                        />
                    </FormControl>}
                {extraFields && extraFields?.indexOf(ExtraRegistrationFields.CITY) >= 0 &&
                    <FormControl className={classes.textFieldContainer}>
                        <TextField
                            className={classes.textField}
                            name="city"
                            required
                            defaultValue={currentUser.city}
                            label={t('cityLabel')}
                        />
                    </FormControl>}
                {extraFields && extraFields?.indexOf(ExtraRegistrationFields.POSITION) >= 0 &&
                    <FormControl className={classes.textFieldContainer}>
                        <TextField
                            className={classes.textField}
                            name="position"
                            required
                            label={t('positionLabel')}
                        />
                    </FormControl>}
                {extraFields && extraFields?.indexOf(ExtraRegistrationFields.UNIT) >= 0 &&
                    <FormControl className={classes.textFieldContainer}>
                        <GazpromUnitSelect
                            className={classes.textField}
                        />
                    </FormControl>}
                {extraFields && extraFields?.indexOf(ExtraRegistrationFields.PREDICTION) >= 0 &&
                    <FormControl className={classes.textFieldContainer}>
                        <NostraPrediction/>
                    </FormControl>}
                {extraFields && extraFields?.indexOf(ExtraRegistrationFields.REGION) >= 0 &&
                    <FormControl className={classes.textFieldContainer}>
                        <RegionSelect
                            className={classes.textField}
                        />
                    </FormControl>}

                <ChallengeLocationSelect locations={challengeData.locations}
                                         locationDescription={challengeData.locationDescription}/>

                {challengeData.teamRegistration &&
                    <TeamRegistrationView config={challengeData.teamRegistration} currentUser={currentUser}/>}
            </>
        )
    }
}

const useStyles = makeStyles({
    textField: {
        width: "100%",
        maxWidth: "30rem",
    },
    textFieldContainer: {
        width: "100%",
        display: "block",
        marginBottom: "1rem"
    },
    emailPlaceholder: {
        fontSize: "0.85rem",
        color: theme.greyTextColor,
        marginTop: "0.5rem",
    },
})